import { SplatMeshRenderer } from "@/components/r3f/renderers/splat-mesh-renderer";
import { GaussianSplatsObject } from "@/object-cache";
import { JSX } from "react";
import { useToolsAcquaintance } from "../tools/tools-acquaintance-context";

type FlyWalkGaussianSplatsRendererProps = {
  /** The current active gaussian splats */
  gaussianSplats: GaussianSplatsObject | null;
};

/** @returns a wrapper component to instantiate or not the gaussian splats renderer */
export function FlyWalkGaussianSplatsRenderer({
  gaussianSplats,
}: FlyWalkGaussianSplatsRendererProps): JSX.Element | null {
  const { clippingPlanes } = useToolsAcquaintance();

  if (!gaussianSplats) {
    return null;
  }
  return (
    <SplatMeshRenderer
      splatMesh={gaussianSplats}
      clippingPlanes={clippingPlanes}
    />
  );
}
